import { render, staticRenderFns } from "./BestAfterlanding.vue?vue&type=template&id=753c4be0"
import script from "./BestAfterlanding.vue?vue&type=script&lang=js"
export * from "./BestAfterlanding.vue?vue&type=script&lang=js"
import style0 from "./BestAfterlanding.vue?vue&type=style&index=0&id=753c4be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports